import Cleave from 'cleave.js';

/**
 * Hook into Alpine so that it is available no matter at which point Alpine loads.
 */
document.addEventListener('alpine:init', () => {

    Alpine.data('creditCard', (numberInputId, typeElementId, expDateElementId, cvvElementId) => ({

        /**
         * @var string identifier attribute for credit card number input
         */
        numberInputId: numberInputId,

        /**
         * @var string identifier attribute for credit card type element
         */
        typeElementId: typeElementId,

        /**
         * @var string identifier attribute for credit card type element
         */
        expDateElementId: expDateElementId,

        /**
         * @var string identifier attribute for credit card CVV element
         */
        cvvElementId: cvvElementId,

        /**
         * @var {Cleave} instance of credit card number mask
         */
        numberMask: null,

        /**
         * @var {HTMLElement} instance of credit card type mas
         */
        typeElement: null,

        /**
         * @var {Cleave} instance of credit card expiration date mask
         */
        expDateMask: null,

        /**
         * @var {Cleave} instance of credit card CVV mask
         */
        cvvMask: null,

        cardType: '',

        /**
         * Initialize the mask plugin instance for the number element.
         *
         * @param {string|undefined} modelPath path to the Livewire model.
         * @param {string|undefined} listenerType (change, blur, ...)
         */
        initNumberMask(modelPath, listenerType) {
            this.typeElement = document.getElementById(this.typeElementId);
            this.numberMask = new Cleave(`#${this.numberInputId}`, {
                creditCard: true,
                onCreditCardTypeChanged: function (type) {
                    this.cardType = type;
                }.bind(this),
            });
            this.setListenerIfModelNotEmpty(this.numberInputId, modelPath, listenerType);
        },

        /**
         * Initialize the mask plugin instance for the CVV element.
         *
         * @param {string|undefined} modelPath path to the Livewire model.
         * @param {string|undefined} listenerType (change, blur, ...)
         */
        initCvvMask(modelPath, listenerType) {
            this.cvvMask = new Cleave(`#${this.cvvElementId}`, {
                numeral: true,
                numeralThousandsGroupStyle: 'none',
                numeralPositiveOnly: true,
                numeralDecimalScale: 0,
            });
            this.setListenerIfModelNotEmpty(this.cvvElementId, modelPath, listenerType);
        },

        /**
         * Set the event listener for Livewire model if model is specified.
         *
         * @param {string} inputId input element ID.
         * @param {string|undefined} model path to the Livewire model.
         * @param {string|undefined} listenerType (change, blur, ...)
         */
        setListenerIfModelNotEmpty(inputId, model, listenerType) {
            if (model) {
                this.setLivewireModelListener(inputId, model, listenerType);
            }
        },

        /**
         * Set the event listener to sync the input value for Livewire model.
         *
         * @param {string} inputId input element ID.
         * @param {string} modelPath path to the Livewire model.
         * @param {string|undefined} listenerType (change, blur, ...)
         */
        setLivewireModelListener(inputId, modelPath, listenerType = 'change') {
            const input = document.getElementById(inputId);
            input.addEventListener(listenerType, () => this.$wire.set(modelPath, input.value));
        },
    }));
});